import React from 'react'
import { Link, graphql, StaticQuery } from 'gatsby'
import Layout from '../components/Layout'
import Seo from '../components/Seo'
import kebabCase from '../utils/kebabCase'

const TagsPage = ({ data }, props) => {
	const siteTitle = data.site.siteMetadata.title
	const group = data.allMarkdownRemark.group

	return (
		<Layout location={props.location} title={siteTitle}>
			<Seo
				title="All posts"
				keywords={[`blog`, `gatsby`, `javascript`, `react`]}
			/>
			<div className="inner-wrap-container">
				<h1 className="page-title text-center h2">All Tags</h1>

				<div className="row" id="sortable-wrap">
					{group.map(tag => (
						<div
							className="col-md-4 col-sm-6 card-wrap tag-card-wrap visible animate fade-in"
							data-name={tag.fieldValue}
							data-count={tag.totalCount}
							key={tag.fieldValue}
						>
							<div className="tag-card text-center">
								{/* {{#if feature_image}}
                    <a href="{{url}}">
                        <div className="tag-image" style="background-image:url({{feature_image}});"></div>
                    </a>
                    {{/if}} */}
								<div className="tag-info">
									<h2 className="tag-name h3">
										<Link to={`/tags/${kebabCase(tag.fieldValue)}`}>
											{tag.fieldValue}
										</Link>
									</h2>
									<div className="post-count">
										{tag.totalCount === 1
											? `1 Post`
											: `${tag.totalCount} Posts`}
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</Layout>
	)
}

const pageQuery = graphql`
	query {
		site {
			siteMetadata {
				title
			}
		}
		allMarkdownRemark(limit: 2000) {
			group(field: frontmatter___tags) {
				fieldValue
				totalCount
			}
		}
	}
`

export default props => (
	<StaticQuery
		query={pageQuery}
		render={data => (
			<TagsPage location={props.location} data={data} {...props} />
		)}
	/>
)
